import styled, { css } from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';

export const CheckboxContainer = styled.div`
  > input {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  > label {
    display: flex;
    gap: var(--spacing-s);
    cursor: pointer;

    > svg {
      color: var(--color-interface-layout-darker);
    }
  }

  :has(input:checked) {
    > label > svg {
      color: var(--color-interface-secondary-normal);
    }
  }

  > label > svg {
    &:hover,
    &:focus {
      color: var(--color-interface-secondary-lighter) !important;
    }
  }

  :has(input:disabled) {
    pointer-events: none;

    > label > svg {
      color: var(--color-interface-layout-darker);
    }
  }
`;
